import 'amfe-flexible'
import Vue from 'vue'
import App from './App'
import { Dialog } from 'vant'
import { router } from './router'
import store from './store/index'
import { loadJsFunction, getIOSToken } from './utils/native'
// 全局注册dialog组件
Vue.use(Dialog)
// 加载app需要调用的方法
loadJsFunction()
// 获取token
getIOSToken()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
